export const BROWSER_SUPPORT_ERROR = 'NotSupportedError';
export const NOT_OFFICIALLY_SUPPORTED = 'NotOfficiallySupported';
export const NOT_ALLOWED_ERROR = 'NotAllowedError';
// Legacy Chrome aliases are still reported by older webviews, so they are treated as their modern counterparts
export const PERMISSION_DENIED_ERROR = 'PermissionDeniedError';
export const SECURITY_ERROR = 'SecurityError';
export const NOT_FOUND_ERROR = 'NotFoundError';
export const DEVICES_NOT_FOUND_ERROR = 'DevicesNotFoundError';
export const OVERCONSTRAINED_ERROR = 'OverconstrainedError';
export const TWILIO_SUPPORTED_BROWSERS_LINK = 'https://www.twilio.com/docs/video/javascript#supported-browsers';
